export default "__VITE_ASSET__VNfNNwOO__"